// NOMBASE — Drive icon
// Original monochrome icon representing a cloud/storage drive. Designed
// in-house — NOT a Google Drive knock-off. Uses the same stroke language
// as the rest of our Lucide-based UI so it composes with every tile and
// sidebar slot without visual noise.
import React from 'react';

export default function DriveIcon({ className = '', strokeWidth = 1.75, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* Top face — slight perspective trapezoid */}
      <path d="M5 7.5 L12 4 L19 7.5" />
      {/* Left + right side edges */}
      <path d="M5 7.5 V16" />
      <path d="M19 7.5 V16" />
      {/* Front face — the "drive bay" */}
      <rect x="5" y="12" width="14" height="7" rx="1.5" />
      {/* Status LED + slot */}
      <circle cx="16" cy="15.5" r="0.6" fill="currentColor" />
      <path d="M7.5 15.5 H12" />
    </svg>
  );
}
